<template>
    <div class="superbill-form-modal">

        <b-btn size="sm" variant="primary"
               @click="showModal()">
            {{ buttonLabel }}
            <shs-icon name="calculator"></shs-icon>
        </b-btn>

        <b-btn size="sm" variant="primary" class="ml-3"
               v-if="superBillIsNonEmpty"
               @click="downloadForm1500()">
            {{ $i18n.gt('LABEL_DOWNLOAD_FORM_1500') }}
            <shs-icon name="document"></shs-icon>
        </b-btn>

        <!-- modal -->
        <b-modal hide-footer size="xl"
                 :id="modalId"
                 :title="buttonLabel">

            <superbill-form :survey-note="surveyNote">
            </superbill-form>

        </b-modal>

    </div>
</template>

<script>

/**
 * Button and modal for displaying a SuperbillForm
 */
export default {
    name: 'SuperbillFormModal',
    props: {
        surveyNote: Object,
    },
    computed: {
        modalId() {
            return `superbillModal_${this.surveyNote.id}`
        },
        superBillIsNonEmpty() {
            const superbill = this.surveyNote.superbill
            return superbill.cptCodes.length || superbill.dxCodes.length
        },
        buttonLabel() {
            return this.superBillIsNonEmpty ? this.$i18n.gt('LABEL_REVISE_SUPERBILL') : this.$i18n.gt('LABEL_CREATE_SUPERBILL')
        }
    },
    methods: {
        showModal() {
            this.$bvModal.show(this.modalId)
        },
        downloadForm1500() {
            this.$api.downloadForm1500(this, this.surveyNote.id)
                .catch((e) => {
                    this.$utils.handleError(e, 'Could not download file')
                })
        }
    },
}
</script>

<style lang="scss">

.superbill-form-modal {
    display: inline-block;
}

</style>
